import common from "../common";
import AudioParams from "../utils/AudioParams";
import Button from "../ui/Button";

export default class Scene extends P3.Scene {
    constructor(sceneId)
    {
        super();
        this.sceneId = sceneId;
        this.bg = null;
        this.buttons = {};
        this.audioLoopParams = new AudioParams();
        this.audioLoopParams.loop = true;
        this.signalListeners = [];
        this.particles = [];
    }

    init(bg)
    {
        console.log(this.sceneId);
        if(bg)
        {
            this.bg = common.display.sprite({asset:bg, parent:this});
        }
        super.init();
    }

    destroy()
    {
        for(var i in this.signalListeners)
        {
            this.signalListeners[i].detach();
        }
        for(var i in this.buttons)
        {
            this.buttons[i].destroy();
        }
        for(var i in this.particles)
        {
            this.particles[i].destroy();
        }
        document.removeEventListener("backbutton", this.onBackKeyDown, false);

        super.destroy({children: true});
    }

    resize()
    {
        this.x = (P3.View.width - common.STAGE_WIDTH) * 0.5;
        if(this.buttons.home)
        {
            this.buttons.home.x = common.STAGE_HALF_WIDTH + (P3.View.width/2) - 50;
        }
    }

    update()
    {
        for(var i in this.particles)
        {
            this.particles[i].update(P3.Ticker.dt * common.timeStretch);
        }
    }

    addHomeButton()
    {
        this.buttons.home = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_medium_out'),
            P3.assets.texture('btn_primary_medium_over'),
            P3.assets.texture('btn_primary_medium_out'),
            P3.assets.texture('icon_home')
        ));
        this.buttons.home.id = 'home';
        this.buttons.home.y = 50;
        this.signalListeners.push(this.buttons.home.signals.click.add(() => {
            this.signals.home.dispatch();
        }, this));
        this.addChild(this.buttons.home);
    }

    getId()
    {
        return this.sceneId;
    }
}